module.exports = __webpack_public_path__ + "img/success.a682d17f.png";